module.exports = __webpack_public_path__ + "media/images/photo/plans/common/img_engagement-studio-photo-ffb1c427521360aa21edb2b4e42fbfcf.png";